module.exports = __webpack_public_path__ + "img/page_cam_header.da23e757.png";